<div class="product-order-option">
  <div class="product-order-option-header-background product-order-option-header">
    <img src="{{getLogoUrl()}}" class="{{isTrial ? 'product-order-options-logo-large' : 'product-order-options-logo'}}">
  </div>
  <div class="product-order-option-body">
    <div class="product-detail-order-title" [translate]="orderOption.titleKey"></div>
    <div class="product-detail-order-description-text" [innerHTML]="orderOption.descriptionKey | translate"></div>
    <div *ngIf="orderOption?.priceDetail && !hideButton" class="product-detail-order-below-part bottom">
      <div *ngIf="orderOption?.showPrices">
        <app-order-button class="smallHeight"
                          *ngIf="orderOption?.showPrices"
                          [x]="x"
                          [y]="y"
                          [pack]="pack"
                          [isDayPass]="isDayPass"
                          [isTrial]="isTrial"
                          [ownerComponent]="ownerComponent"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()"
                          [buttonTextKey]="label">
        </app-order-button>
      </div>
      <div *ngIf="orderOption?.showPrices" class="product-order-price">
        <div class="price-box">
          <div class="price">
            <span *ngIf="hasPromo || (isDayPass && hasPromoDayPass && !isPromoSamePrice)" class="promo-original-price">
              <ng-container *ngIf="getCurrentLang !== 'fr'" class="currency">€</ng-container>
              <span>{{textIntegerPart}}{{textDecimalPart}}</span>
            </span>
            <div *ngIf="getCurrentLang !== 'fr'" class="price-left">€</div>
            <div class="price-left">{{priceBeforeComma}}</div>
            <div class="price-right"><span class="comma">{{getPriceTextDecimalPart}}</span>
              <div *ngIf="!isDayPass">
                <div class="after">/<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span></div>
              </div>
              <div *ngIf="isDayPass">
                <div class="after"><span [translate]="'eos-tv-shop-ii.title.play-sports-daypass-24-hr'"></span></div>
              </div>
            </div>
          </div>
          <span *ngIf="promoLabel && !isDayPass"  class="promo-label" [translate]="'eos-tv-shop-ii.lbl.' + promoLabel"
                [translateParams]="{ duration: promoDuration }">gedurende x maand(en)</span>
        </div>
      </div>
    </div>
    <div class="bottom-price" *ngIf="!orderOption.priceDetail && !hideButton">
      <div class="bottom-price-container">
        <app-order-button class="smallHeight"
                          *ngIf="orderOption?.showPrices"
                          [x]="x"
                          [y]="y"
                          [isTrial]="isTrial"
                          [ownerComponent]="ownerComponent"
                          (emitOnEnterPressed)="onEmitOrderTrial($event)"
                          (emitOnBack)="onBack()"
                          [buttonTextKey]="label">
        </app-order-button>
      </div>
    </div>
  </div>
</div>
